import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Header from "../common/Header";
import ItemTitle from "./rows/ItemTitle";
import ItemDetails from "./rows/ItemDetails";
import ResultEmptyPanel from "./panels/ResultEmptyPanel";
import ResultLoaderPanel from "./panels/ResultLoaderPanel";
import ResultPanel from "./panels/ResultPanel";
import NotificationBar from "../Parts/NotificationBar.jsx";
import Pagination from "../common/Pagination";
import { ORDER_ADDRESSES_PER_PAGE } from "../../constants/Constants";
import { getQueryVariable } from "../../utils/utils";

const styles = () => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    overflowY: "auto",
  },

  main: {
    background: "#FAFAFA",
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },

  content: {
    width: "85%",
    maxWidth: "1222px",
    margin: "30px auto 90px auto",
    boxSizing: "border-box",
  },

  section: {
    width: "100%",
    padding: "22px 25px 32px 25px",
    background: "#FFFFFF",
    boxShadow: "0px 1px 2px #0000001F",
    borderRadius: "4px",
    boxSizing: "border-box",
  },

  title: {
    fontSize: "16px",
    color: "#181819",
    fontWeight: "bold",
    paddingBottom: "9px",
    borderBottom: "1px solid #E7E9EB",
    marginBottom: "28px",
    display: "flex",
    alignItems: "center",
    width: "100%",
  },

  notificationContainer: {
    position: "fixed",
    zIndex: 10000,
    top: 10,
    width: "98%",
    left: "1%",
  },

  paginationContainer: {
    margin: "40px 0px 0px 0px",
  },
});

class OrderDetail extends React.Component {
  initialState = {
    showNotification: false,
    message: "",
    messageType: "green",
  };

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentDidMount() {
    this.props.getUserInfo();
    this.props.getOrderById(this.props.match.params.id, { is_detail_page: 'true' });
    this.props.getOrderAddresses(
      this.props.match.params.id,
      {
        page: getQueryVariable(this.props.search, "page") || 1,
        per_page: ORDER_ADDRESSES_PER_PAGE,
        paging: 1,
      },
      true
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search) {
      this.props.getOrderAddresses(
        this.props.match.params.id,
        {
          page: getQueryVariable(this.props.search, "page"),
          per_page: 11,
          paging: 1,
        },
        false
      );
    }
    if (prevProps.message === "" && this.props.successMessage && this.props.successMessage !== "") {
      this.displayNotification(this.props.successMessage, "success");
    } else if (prevProps.errorMessage === "" && this.props.errorMessage && this.props.errorMessage !== "") {
      this.displayNotification(this.props.errorMessage, "error");
    } else if (prevProps.shortMessage === "" && this.props.shortMessage && this.props.shortMessage !== "") {
      this.displayNotification(this.props.shortMessage, "green");
    }
  }

  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  renderNotification = () => {
    const { classes } = this.props;
    if (this.state.showNotification) {
      return (
        <div className={classes.notificationContainer}>
          <NotificationBar
            message={this.state.message}
            type={this.state.messageType}
            open={this.state.showNotification}
            onHandleClose={() => {
              this.setState({ showNotification: false });
            }}
            autoClose={false}
            style={{
              width: this.state.messageType === "green" ? "fit-content" : "100%",
            }}
          ></NotificationBar>
        </div>
      );
    }
  };

  render() {
    const {
      classes,
      isOrderLoading,
      order,
      isLoadingOrderAddresses,
      orderAddresses,
      pageInfo,
      pathname,
      location,
    } = this.props;

    return (
      <div className={classes.root}>
        <Header
          title="注文履歴"
          secondaryTitle="注文詳細"
          type="dark"
          hasBackBtn={false}
          onTitleClicked={
            location.state && location.state.hasOwnProperty("ownerType") && location.state.hasOwnProperty("selectedYear") && location.state.hasOwnProperty("selectedMonth")
              ? () => this.props.goTo("/orders", {
                ownerType: location.state.ownerType,
                selectedYear: location.state.selectedYear,
                selectedMonth: location.state.selectedMonth,
              })
              : () => this.props.goTo("/orders")
          }
        />
        <div className={classes.main}>
          <div className={classes.content}>
            <div className={classes.section}>
              <ItemTitle isLoading={isOrderLoading} item={order} />
              <ItemDetails isLoading={isOrderLoading} item={order} />
              <div className={classes.title} style={{ fontWeight: "normal", marginBottom: "0px" }}>
                送付先
              </div>

              {(() => {
                if (isLoadingOrderAddresses) {
                  return <ResultLoaderPanel />
                } else if (orderAddresses.length === 0) {
                  return <ResultEmptyPanel />
                } else {
                  return <ResultPanel
                    orderAddresses={orderAddresses}
                    goTo={this.props.goTo}
                  />
                }
              })()}
            </div>

            {orderAddresses &&
              orderAddresses.length > 0 &&
              pageInfo && (
                <div className={classes.paginationContainer}>
                  <Pagination
                    currentPage={pageInfo.current_page}
                    lastPage={pageInfo.last_page}
                    total={pageInfo.total}
                    perPage={ORDER_ADDRESSES_PER_PAGE}
                    showLastPage={true}
                    disabled={isLoadingOrderAddresses}
                    disableNavigation={false}
                    onChange={(data) => {
                      if (
                        location.state &&
                        location.state.hasOwnProperty("ownerType") &&
                        location.state.hasOwnProperty("selectedYear") &&
                        location.state.hasOwnProperty("selectedMonth")
                      ) {
                        this.props.goTo(pathname + "?page=" + data["page"], {
                          ownerType: location.state.ownerType,
                          selectedYear: location.state.selectedYear,
                          selectedMonth: location.state.selectedMonth,
                        });
                      } else {
                        this.props.goTo(pathname + "?page=" + data["page"]);
                      }
                    }}
                  />
                </div>
              )}
          </div>
        </div>
        {this.renderNotification()}
      </div>
    );
  }
}

OrderDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  getOrderById: PropTypes.func.isRequired,
  getOrderAddresses: PropTypes.func.isRequired,
  match: PropTypes.object,
  location: PropTypes.object,
  search: PropTypes.string,
  isOrderLoading: PropTypes.bool,
  isLoadingOrderAddresses: PropTypes.bool,
  order: PropTypes.object,
  orderAddresses: PropTypes.array,
  pageInfo: PropTypes.object,
  pathname: PropTypes.string,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  successMessage: PropTypes.string,
};

export default withStyles(styles)(OrderDetail);



// WEBPACK FOOTER //
// ./src/components/OrderDetail/OrderDetail.jsx